import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { getFactoryOf } from '@angular/core/src/render3';
import { Router, ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { StorageService } from '../Services/service.StorageService';
import { User } from '../Models/USermodel';
import { ApiService } from '../common/API/api.service';
import { apiUrlComponent } from '../common/api.url.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthToken } from '../Models/AuthToken.model';
import { CommonService } from '../Services/common.service';

declare var config;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  private user = new User();
  returnUrl: string;
  public isvalid: any;
  TokenData: AuthToken;

  private readonly notifier: NotifierService;
  constructor(private apiUrl: apiUrlComponent, private fb: FormBuilder, private router: Router, private spinner: NgxSpinnerService,
    notifierService: NotifierService, private apiService: ApiService, private storage: StorageService, private _service: CommonService) {
    this.form = this.fb.group({
      Username: [''],
      Password: [''],
    });
    this.notifier = notifierService;
  }

  ngOnInit() {
    debugger;
    sessionStorage.removeItem('user');
    setTimeout(() => {
      sessionStorage.clear();
    }, 1000 * 60 * 60 * 24)
  }

  submit(): any {
    debugger;

    if (this.form.value.Username == "" || this.form.value.Password == "") {
      this.notifier.notify('error', 'Please fill required fields');
    }
    else {
      this.spinner.show();
      this.user.username = this.form.value.Username;
      this.user.password = this.form.value.Password;
      var reqbody = {
        username: this.form.value.Username,
        password: this.form.value.Password
      }

      this.apiService.post(config.WebApiPath + 'api/login/UserLogin', reqbody).subscribe(result => {
        debugger;
        this.spinner.hide();
        if (result.IsSuccess) {
          this.storage.setUser(result.Data);
          sessionStorage.setItem('user', JSON.stringify(result.Data));
          //this.router.navigateByUrl('/baseEnterprise');
          // this.router.navigateByUrl('/PhoneModels');
          this.router.navigateByUrl('/UploadPrice');
          //this.genrateToken();
          return true;
        } else {
          this.notifier.notify('error', 'Invalid Username or Password');
          this.router.navigate(['']);
        }
      },
        error => {
          this.spinner.hide();
          console.log(error);
        }
      );
    }
  }

  public genrateToken() {
    this.spinner.show();
    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
    if (this.TokenData === null || this.TokenData === undefined) {
      const userdata = {
        Username: this.form.value.Username,
        Password: this.form.value.Password,
        grant_type: 'password',
      }
      this._service.PostToken(userdata, 'token').then(
        result => {
          if (result !== undefined) {
            this.TokenData = new AuthToken();
            this.TokenData.access_token = result.access_token;
            this.TokenData.expires_in = result.expires_in;
            this.TokenData.refresh_token = result.refresh_token;
            this.TokenData.token_type = result.token_type;
            sessionStorage.setItem('Token', JSON.stringify(this.TokenData));
            this.spinner.hide();
            this.router.navigateByUrl('/PhoneModels');
          }
        },
        error => {
          if (error.status === 401) {
            this.router.navigate(['/unauthorized']);
            this.spinner.hide();
          }
          console.log(error);
          throw error;
        });
    }
    else{
      this.router.navigateByUrl('/PhoneModels');
    }
    this.spinner.hide();
  }

}
